import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'wsb-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  standalone: false
})
export class SearchInputComponent {
  @Input() placeholder = 'common_search';

  @Output() filterClear = new EventEmitter();

  @Output() filterChange = new EventEmitter<string>();

  value = '';

  constructor() {}

  valueChanged(value: string): void {
    this.filterChange.emit(value);
  }

  clear() {
    this.value = '';
    this.filterClear.emit();
    this.valueChanged(this.value);
  }
}
